import { appBaseName } from '../constants';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter, Route, Switch } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { fetchData } from '../actions/actionCreators';
import iNoBounce from 'inobounce';

import Sidebar from './Sidebar';
import Single from './Single';
import TravelMap from './TravelMap';
import PrevalenceMap from './PrevalenceMap';

// Use different route names for vaxiplace and vaxihub
window.prevalence_tab_title = 'Disease Prevalence';
window.prevalence_tab_slug = 'disease-prevalence';

const useMockDataForDevEnv = false;

const endpoints = {
	data:
		document.location.hostname === 'localhost' || document.location.hostname.includes('192.168.1')
			? useMockDataForDevEnv
				? // ? 'https://vaxiplace2016.schweb.net.au/mapdata'
				  // ? 'http://vaccinehub2018.schweb.net.au/mapdata'
				  'http://vaxiplace2017.adrenalinmedia.com/mapdata'
				: 'https://www.vaccinehub.com.au/mapdata' // Requires the use of a proxy serve on port 3001
			: '/mapdata',
	// appBaseName + '/sample-map-data/new-data.json',
	geoJSON: appBaseName + '/app/data/countries-v2.geojson',
};

class App extends React.Component {
	componentWillMount() {
		window.onload = () => {
			this.windowLoaded = true;
			this.hidePreloader(this.props.isLoading);
		};
	}
	componentDidMount() {
		this.props.fetchData(endpoints);
	}
	componentWillReceiveProps(nextProps) {
		this.hidePreloader(nextProps.isLoading);
	}
	hidePreloader(fetchIsLoading) {
		if (preloader && this.windowLoaded && !fetchIsLoading) {
			iNoBounce.enable();
			preloader.classList.add('is-complete');
			setTimeout(() => {
				preloader.classList.add('is-hidden');
			}, 2000);
		}
	}
	render() {
		if (this.props.hasErrored) {
			return <p>Sorry, an error occured with the data feed.</p>;
		}

		if (this.props.isLoading) {
			return <p>Loading ...</p>;
		}

		// active map classes
		let travelActive;
		let travelActiveCls = '';
		const prevalenceActive = this.props.history.location.pathname.includes(`/${window.prevalence_tab_slug}`);
		if (this.props.history.location.pathname.includes('/travel')) {
			travelActive = true;
			travelActiveCls = 'is-active';
		}

		// set unique CSSTransition key for switch, only applies to url routes higher than 1 lvl ('/travel/au')
		let currentKey = this.props.location.pathname.split('/').length > 2 ? this.props.location.pathname : '/';

		return (
			<div className={`travel-map${this.props.isFullscreen ? ' is-fullscreen' : ''}`}>
				<a href="/" className="home-btn hide-mobile">
					<div className="icon icon-home" />
					<div className="home-btn-label">{window.vaxiplace ? 'VAXIPLACE' : 'VACCINE HUB'}</div>
				</a>

				<a className="sanofi-logo">
					<span className="icon icon-sanofi-logo" />
				</a>

				<Sidebar />

				<TransitionGroup>
					<CSSTransition key={currentKey} timeout={1000} classNames="single-slide">
						<div>
							<Switch location={this.props.location}>
								<Route exact path="/travel/:country" component={Single} />
							</Switch>
						</div>
					</CSSTransition>
				</TransitionGroup>

				<Switch>
					<Route
						path="/:primaryRoute/:secondaryRoute?" // allows access to route params outside the actual route
						render={() => (
							<Fragment>
								<TravelMap history={this.props.history} active={travelActive} className={travelActiveCls} />
								<PrevalenceMap history={this.props.history} active={prevalenceActive} />
							</Fragment>
						)}
					/>
				</Switch>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		data: state.data,
		hasErrored: state.fetchDataError,
		isLoading: state.fetchDataLoading,
		isFullscreen: state.visibility.isFullscreen,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchData: (url) => dispatch(fetchData(url)),
	};
};

const AppConnected = connect(mapStateToProps, mapDispatchToProps)(App);

export default withRouter(AppConnected);
